import QrRedirect from "./QrRedirect";

export default QrRedirect;
